import { render, staticRenderFns } from "./editBase.vue?vue&type=template&id=2df1ada4&scoped=true&"
import script from "./editBase.vue?vue&type=script&lang=js&"
export * from "./editBase.vue?vue&type=script&lang=js&"
import style0 from "./editBase.vue?vue&type=style&index=0&id=2df1ada4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df1ada4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\www\\ssz_gold_backend\\multi_merchant_web\\gold_admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2df1ada4')) {
      api.createRecord('2df1ada4', component.options)
    } else {
      api.reload('2df1ada4', component.options)
    }
    module.hot.accept("./editBase.vue?vue&type=template&id=2df1ada4&scoped=true&", function () {
      api.rerender('2df1ada4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/goods/editBase.vue"
export default component.exports